import { JwtAuthService } from "./../../../services/jwt-auth.service";
import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
    selector: "app-admin-layout",
    imports: [RouterOutlet, FlexLayoutModule],
    templateUrl: "./admin-layout.component.html",
    styleUrl: "./admin-layout.component.scss"
})
export class AdminLayoutComponent {
    private readonly jwtAuth = inject(JwtAuthService);
    constructor() {
        this.jwtAuth.checkUserToken();
    }
}
